import React, { useState } from "react";

// material components
import { TablePagination, Typography } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import Table from '@material-ui/core/Table';
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import GlobalTableHead from "../global/Table/GlobalTableHead";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FilterIcon from "../shipments/FilterIcon";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { Slide } from "@material-ui/core";

// custom components
import SearchableTable from "../global/Search/SearchableTable";
import ExpandedPurchaseOrder from "./ExpandedPurchaseOrder";

// constants
import { LIST_PURCHASE_ORDERS_CELLS, ROW_KEYS, ROWS_PER_PAGE_LABEL, STATUS, FILTER } from "./constants";
import { ASC, DESC } from "../global/constants";
import { DEFAULT_ROWS_PER_PAGE, DEFAULT_SORT_BY_HEAD_CELL, } from "./constants";


// styling
import "./PurchaseOrdersTable.css"
import PropTypes from "prop-types";
import TableFooter from "@material-ui/core/TableFooter";
import SearchField from "../global/Search/SearchField";
import CustomTableHeader from "../global/Table/CustomTableHeader";
import RenderPurchaseOrderPDFPreview from "./RenderPurchaseOrderPDFPreview";
import PurchaseOrderDetails from "./PurchaseOrderDetails";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PurchaseOrderFiltersDialog from "./PurchaseOrderFiltersDialog";
import FilterTagsBar from "../shipments/FilterTagsBar";
import LocationSelectBox from "../global/subcomponents/locationSelectBox/LocationSelectBox";

class PurchaseOrdersTable extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            order: DESC,
            orderBy: DEFAULT_SORT_BY_HEAD_CELL,
            selectedOrder: [],
            isSearch: false,
            searchValue: '',
            searchRows: 0,
            isFilterApplied: false,
            filtersMapBeforeOpenDialog: {},
            selectedStatus: [],
            dropdownAll: false,
            filtersOpen: false,
            suppliers: [],
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            filtersMap: {},
            deletedTagsWithCookies: [],
            filterShipAddressId : this.props.userInfo.selectedLocationId,
        };
    }

    async componentDidMount() {
        let changeBack = false

        await this.setState({
            selectedStatus: this.props.tableSetting?.purchaseOrderFilterSetting,
            searchValue: this.props.searchText
        })

        let storage = JSON.parse(localStorage.getItem("Purchase Orders"))

        if (storage) {
            this.getNewDates()
            const expiry = parseInt(JSON.parse(localStorage.getItem("expiry")))
            if (storage.fromDate !== null && storage.fromDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.closeFilters(true)
                } else {
                    changeBack = true
                }
            }
            else if (storage.toDate !== null && storage.toDate !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.closeFilters(true)
                } else {
                    changeBack = true
                }
            }
            else if (storage.suppliers !== null && storage.suppliers !== undefined) {
                if (expiry > new Date().getTime()) {
                    this.closeFilters(true)
                } else {
                    changeBack = true
                }
            }
            if (changeBack) {
                localStorage.removeItem("Purchase Orders")
                this.setState({
                    fromDate: this.getFromDate(),
                    toDate: this.getToDate(),
                    suppliers: [],
                    filtersMap: {}
                })
            }
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.tableSetting !== this.props.tableSetting) {
            this.setState({ selectedStatus: this.props.tableSetting?.purchaseOrderFilterSetting })
        }
        if (prevProps.searchText !== this.props.searchText) {
            this.setState({ searchValue: this.props.searchText })
        }
    }

    getFromDate = () => {
        var date = new Date()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setDate(date.getDate() - 14)
        return date;
    }

    getToDate = () => {
        var date = new Date()
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        return date;
    }

    isDefaultFromDate = (someDate) => {
        const defaultFromDate = this.getFromDate()
        return someDate.getDate() == defaultFromDate.getDate() &&
            someDate.getMonth() == defaultFromDate.getMonth() &&
            someDate.getFullYear() == defaultFromDate.getFullYear()
    }

    getNewDates = () => {
        let filter = {...this.state.filtersMap}
        let storage = JSON.parse(localStorage?.getItem("Purchase Orders"))
        if (storage.fromDate !== null && storage.fromDate !== undefined ) {
            const temp = new Date(storage.fromDate)
            filter.fromDate = temp;
            this.setState({
                fromDate: temp
            })
        }
        if (storage.toDate !== null && storage.toDate !== undefined) {
            const temp = new Date(storage.toDate)
            filter.toDate = temp;
            this.setState({
                toDate: temp
            })
        }
        if (storage.suppliers != null && storage.suppliers !== undefined) {
            filter.suppliers = storage.suppliers
            this.setState({
                suppliers: storage.suppliers
            })
        }
        if (filter) {
            this.setState({
                filtersMap: filter,
            })
        }
    }

    isToday = (someDate) => {
        const today = new Date()
        return someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear()
    }

    handleChangePage = (event, newPage) => {
        this.props.setPage(newPage)
    };

    handleChangeRowsPerPage = (event) => {
        this.props.setRowsPerPage(event.target.value)
        this.props.setPage(0)
    };


    getDisplayed = (rows) => {
        if (!rows)
            return [];
        return [...rows.slice(this.props.page * this.props.rowsPerPage, this.props.page * this.props.rowsPerPage + this.props.rowsPerPage)];
    }

    onSearchValueChange = (event) => {
        this.setState({
            isSearch: event.target.value.length > 0,
            searchValue: event.target.value
        });
        this.props.setPage(0)
        this.props.handleSearchTextChange(event)
    }

    handleDenseChange = (event) => {
        this.setState({
            dense: event.target.checked,
        });
    }

    handleStatusChange = (event) => {
        let checked = event.target.checked
        if (checked) {
            this.setState({
                selectedStatus: [...this.state.selectedStatus, event.target.name]
            });
        }
        // remove from the list
        else {
            let index = this.state.selectedStatus.indexOf(event.target.name)
            let selected = this.state.selectedStatus
            selected.splice(index, 1)
            this.setState({
                selectedStatus: selected
            });
        }

        this.onFiltersInputChange(event);
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === ASC;
        this.setState({
            order: isAsc ? DESC : ASC,
            orderBy: property,
        });
    };

    handleSelectAllClick = () => {
        const isDropdownAll = !this.state.dropdownAll
        this.setState({
            dropdownAll: isDropdownAll
        })
    }
    fetchCreatedPurchaseOrderPreview = (purchaseOrderDate) => {
        this.props.storeCreatedPurchaseOrderPreview([])
        this.props.previewCreatedPurchaseOrder(purchaseOrderDate)
        this.props.updateField("previewing", true)
        this.props.updateField("previewingName", purchaseOrderDate)
        this.props.updateHasPurchaseOrderEmailTemplate(purchaseOrderDate)
        this.setState({
            showingPurchaseOrder: purchaseOrderDate
        })
    }

    getFilteredPurchaseOrderLength = (purchaseOrderList) => {
        if (this.state.selectedStatus) {
            let listCopy = purchaseOrderList
            if (this.state.selectedStatus.includes("showPOsWithoutAttachments")) {
                listCopy = listCopy.filter((item) => !item.packingSlipFiles || item.packingSlipFiles.size == 0)
            }
            return listCopy.filter((item) => this.state.selectedStatus.includes(item.status)).length
        }
        return 0;
    }

    sortBySupplierName = (poList) => {
        if (this.state.suppliers.length > 0) {
            return poList?.filter((po) =>
                po.supplier?.some(supplier => this.state.suppliers.includes(supplier.name))
            );
        }
        return poList
    }

    getStatusFilteredPurchaseOrders = (purchaseOrderList) => {
        if (this.state.selectedStatus) {
            let listCopy = purchaseOrderList
            if (this.state.selectedStatus.includes("showPOsWithoutAttachments")) {
                listCopy = listCopy.filter((item) => !item.packingSlipFiles || item.packingSlipFiles.size == 0)
            }
            return listCopy.filter((item) => this.state.selectedStatus.includes(item.status))
        }
        return [];
    }

    showFiltersDialog = () => {
        const filtersMapClone = { ...this.state.filtersMap };
        this.setState({
            filtersOpen: !this.state.filtersOpen,
            filtersMapBeforeOpenDialog: filtersMapClone
        });
    }

    closeFilters = (apply) => {
        this.setState({
            filtersOpen: false,
        });

        let filters = {}
        if (!apply) {
            filters = { ...this.state.filtersMapBeforeOpenDialog }
            this.resetDateFilters(filters?.fromDate ?? this.getFromDate(), filters?.toDate ?? this.getToDate(), filters?.suppliers ?? [])
            this.setState({
                filtersMap: filters
            })
        } else {
            if (this.state.deletedTagsWithCookies.length > 0) {
                let storage = JSON.parse(localStorage.getItem("Purchase Orders"))
                this.state.deletedTagsWithCookies.forEach((tagName) => {
                    delete storage[tagName]
                })
                localStorage.setItem("Purchase Orders", JSON.stringify(storage))
                if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("Purchase Orders")
                this.setState({deletedTagsWithCookies: []})
            }
            filters = { ...this.state.filtersMap }
            const expiry = new Date().setHours(23, 59, 59, 0);
            if (filters.fromDate !== null && filters.fromDate !== undefined) {
                let existing = localStorage.getItem("Purchase Orders")
                existing = existing ? JSON.parse(existing) : {};
                existing.fromDate = filters.fromDate;
                localStorage.setItem("Purchase Orders", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            if (filters.toDate !== null && filters.toDate !== undefined) {
                let existing = localStorage.getItem("Purchase Orders")
                existing = existing ? JSON.parse(existing) : {};
                existing.toDate = filters.toDate;
                localStorage.setItem("Purchase Orders", JSON.stringify(existing));
                localStorage.setItem("expiry", JSON.stringify(expiry))
            }
            let existing = localStorage.getItem("Purchase Orders")
            existing = existing ? JSON.parse(existing) : {}
            if (filters.suppliers !== null && filters.suppliers !== undefined) {
                existing.suppliers = filters.suppliers
            }
            else {
                delete existing["suppliers"]
            }
            localStorage.setItem("Purchase Orders", JSON.stringify(existing))
            localStorage.setItem("expiry", JSON.stringify(expiry))
            this.applyDateFilters(this.state.fromDate, this.state.toDate)
        }
    }

    clearFiltersMap = () => {
        this.setState({
            filtersMap: {},
            fromDate: this.getFromDate(),
            toDate: this.getToDate(),
            suppliers: [],
        })
    }

    resetDateFilters = (fromDate, toDate, suppliers) => {
        let filtersMapClone = { ...this.state.filtersMap }
        if (!this.isDefaultFromDate(fromDate)) {
            filtersMapClone['fromDate'] = fromDate
        }
        if (!this.isToday(toDate)) {
            filtersMapClone['toDate'] = toDate
        }
        delete filtersMapClone['suppliers']

        this.setState({
            fromDate: fromDate,
            toDate: toDate,
            suppliers: suppliers,
            filtersMap: filtersMapClone,
            deletedTagsWithCookies: [],
        })
    }

    onTagClickedWhenDialogueOpen = (event, tag) => {
        const filtersMap = { ...this.state.filtersMap };
        let tagValue = filtersMap[tag]
        let deletedTagsWithCookies = this.state.deletedTagsWithCookies
        delete filtersMap[tag];
        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem('Purchase Orders'))
            if (storage) {
                if (storage.fromDate !== null && storage.fromDate !== undefined) {
                    if (new Date(storage.fromDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "fromDate"]})
                    }
                }
            }
            this.setState({
                fromDate: this.getFromDate()
            })
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem('Purchase Orders'))
            if (storage) {
                if (storage.toDate !== null && storage.toDate !== undefined) {
                    if (new Date(storage.toDate).getTime() === new Date(tagValue).getTime()) {
                        this.setState({deletedTagsWithCookies: [...deletedTagsWithCookies, "toDate"]})
                    }
                }
            }
            this.setState({
                toDate: this.getToDate()
            })
        }
        if (tag == "suppliers") {
            delete filtersMap["suppliers"]
            this.setState({
                suppliers: []
            })
        }
        this.setState({
            filtersMap: filtersMap,
        });
    }

    onTagClicked = (event, tag) => {

        // the tag name comes as key:value pair as a string, so we split it

        // remove the key from the filters map
        // clone the map, delete the key, set the state
        const filtersMap = { ...this.state.filtersMap };
        delete filtersMap[tag];

        if (tag === 'fromDate') {
            let storage = JSON.parse(localStorage.getItem("Purchase Orders"))
            delete storage.fromDate
            // this.onDateFiltersInputChange('fromDate', this.getFromDate())
            this.setState({
                fromDate: this.getFromDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem("Purchase Orders", JSON.stringify(storage))
            if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("Purchase Orders")
        }
        if (tag === 'toDate') {
            let storage = JSON.parse(localStorage.getItem("Purchase Orders"))
            delete storage.toDate
            // this.onDateFiltersInputChange('toDate', new Date())
            this.setState({
                toDate: this.getToDate()
            }, () => this.applyDateFilters(this.state.fromDate, this.state.toDate))
            localStorage.setItem("Purchase Orders", JSON.stringify(storage))
            if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("Purchase Orders")
        }
        if (tag == "suppliers") {
            let storage = JSON.parse(localStorage.getItem("Purchase Orders"))
            delete storage.suppliers
            this.setState({
                suppliers: []
            })
            localStorage.setItem("Purchase Orders", JSON.stringify(storage))
            if(JSON.stringify(storage) == JSON.stringify({})) localStorage.removeItem("Purchase Orders")
        }

        this.setState({
            filtersMap: filtersMap
        })
    }

    onFiltersInputChange = (event) => {
        let checked = event.target.checked
        let filtersMap = this.props.tableSetting?.purchaseOrderFilterSetting;

        let id = event.target.name;
        if (checked) {
            filtersMap.push(id)
        } else {
            let i = filtersMap.indexOf(id)
            if (i > -1) {
                filtersMap.splice(i, 1);
            }
        }

        this.saveUpdatedFilters(filtersMap)
    }

    onDateFiltersInputChange = (id, value) => {
        if (!value || isNaN(value.getTime())) {
            //User is still editing the date value, do not fetch orders
            this.setState({
                fromDate: id === "fromDate" ? value : this.state.fromDate,
                toDate: id === "toDate" ? value : this.state.toDate
            })
        } else {
            const date = new Date(value.toString().split('GMT')[0] + "Z")
            let filtersMapClone = { ...this.state.filtersMap }
            if (id === 'fromDate' && !this.isDefaultFromDate(value) ||
                id === 'toDate' && !this.isToday(value)) {
                filtersMapClone[id] = date
            }
            this.setState({
                fromDate: id === "fromDate" ? value : this.state.fromDate,
                toDate: id === "toDate" ? value : this.state.toDate,
                filtersMap: filtersMapClone
            })
        }
    }

    applyDateFilters = (fromDate, toDate) => {
        this.props.fetchAllPurchaseOrders({
            fromDate,
            toDate
        })
    }

    saveUpdatedFilters = (filters) => {
        this.props.saveTableSetting({
            userId: this.props.userInfo.userId,
            tableSetting: null,
            pageTitle: this.props.shipmentStatus,
            defaultTable: this.props.defaultTableDisplay,
            changeFilters: false,
            changePurchaseOrderFilters: true,
            purchaseOrderFilters: filters
        })
    }
    handleLocationChange = (location) => {
        this.setState({
            filterShipAddressId: location.shipAddressId
        })
    }

    handleSupplierChange = (value) => {
        let filters = this.state.filtersMap
        if (value.length > 0) {
            filters["suppliers"] = value
        }
        else {
            delete filters["suppliers"]
        }
        this.setState({
            suppliers: value,
            filtersMap: filters,
        })
    }

    render() {
        return (
            <>
                {this.props.previewing &&
                    <RenderPurchaseOrderPDFPreview
                        //allowSave={true}
                        data={this.props.pdfData}
                        //handlePreviewOpen={this.handlePreviewOpen}
                        //handlePreviewClose={this.handlePreviewClose}
                        //open={this.state.previewOpen}
                        handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
                        handlePdfLoadError={this.props.handlePdfLoadError}
                        pdfLoadSuccess={this.props.pdfLoadSuccess}
                        scale={this.props.scale}
                    /> ||
                    <>
                        <FilterTagsBar
                            filtersMap={this.state.filtersMap}
                            onClick={this.state.filtersOpen ? this.onTagClickedWhenDialogueOpen : this.onTagClicked}
                        />
                        <CustomTableHeader
                            isPurchaseOrderTable={true}
                            searchText={this.props.searchText}
                            onSearchValueChange={this.onSearchValueChange}
                            location={
                                <LocationSelectBox
                                    selectedLocationId={this.state.filterShipAddressId}
                                    updateCallback={this.handleLocationChange}
                                />
                            }
                            filterIcon={
                                <Tooltip title={FILTER} style={{ paddingTop: 10 }}>
                                    <IconButton className="filterButton" size='small' aria-label={FILTER} onClick={this.showFiltersDialog} >
                                        <FilterIcon />
                                    </IconButton>
                                </Tooltip>
                            }
                            showFilters={this.state.filtersOpen}
                            filtersComponent={
                                <Slide in={this.state.filtersOpen} mountOnEnter unmountOnExit timeout={300}>
                                    <PurchaseOrderFiltersDialog
                                        isOpen={this.state.filtersOpen}
                                        onOpen={this.showFiltersDialog}
                                        onChange={this.onFiltersInputChange}
                                        clearFilters={this.clearFiltersMap}
                                        onClose={this.closeFilters}
                                        fromDate={this.state.fromDate}
                                        toDate={this.state.toDate}
                                        handleDateChange={this.onDateFiltersInputChange}
                                        handleSupplierChange={this.handleSupplierChange}
                                        supplierOptions={this.props.suppliers}
                                        suppliers={this.state.suppliers}
                                    />
                                </Slide>}
                            customFilterField={
                                <>
                                    <div className="filters">
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('open') : false}
                                                onChange={this.handleStatusChange} name="open"
                                                style={{ color: '#acd685' }} />}
                                            label="Open"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('partial') : false}
                                                onChange={this.handleStatusChange} name="partial"
                                                style={{ color: '#acd685' }} />}
                                            label="Partial"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('completed') : false}
                                                onChange={this.handleStatusChange} name="completed"
                                                style={{ color: '#acd685' }} />}
                                            label="Completed"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('cancelled') : false}
                                                onChange={this.handleStatusChange} name="cancelled"
                                                style={{ color: '#acd685' }} />}
                                            label="Cancelled"
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={this.state.selectedStatus ? this.state.selectedStatus.includes('showPOsWithoutAttachments') : false}
                                                               onChange={this.handleStatusChange} name="showPOsWithoutAttachments"
                                                               style={{ color: '#acd685' }} />}
                                            label="Show POs Without Attachments"
                                        />
                                    </div>

                                </>
                            }
                            pagination={
                                <TablePagination
                                    className="table-pagination"
                                    labelRowsPerPage={ROWS_PER_PAGE_LABEL}
                                    rowsPerPageOptions={[5, 25, 50, 100, {value: this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId).length, label: "All"} ]}
                                    count={!this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId) ? 0 :
                                        this.getFilteredPurchaseOrderLength(this.filterBySearch(this.sortBySupplierName(this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId))))
                                    }
                                    rowsPerPage={this.props.rowsPerPage}
                                    page={this.props.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            }
                        />

                        <TableContainer>
                            <Table
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label={this.props.title}
                            >
                                <GlobalTableHead
                                    isCreatePurchaseOrderTable={false}
                                    isShipmentTable={false}
                                    isPurchaseOrderTable={true}
                                    headCells={LIST_PURCHASE_ORDERS_CELLS}
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={!this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId) ? 0 : this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId).length}
                                    onSelectAllClick={this.handleSelectAllClick}
                                />
                                <TableBody>
                                    {this.getDisplayed(this.stableSort(this.sortBySupplierName(this.getStatusFilteredPurchaseOrders(this.filterBySearchWithSpecificKeys(this.props.rows.filter(row => row.toShipAddressId === this.state.filterShipAddressId), ROW_KEYS))),
                                        this.getComparator(this.state.order, this.state.orderBy))).map((row, index) => {
                                            return (
                                                <>
                                                    <ExpandedPurchaseOrder
                                                        purchaseOrder={row}
                                                        fetchCreatedPurchaseOrderPreview={this.fetchCreatedPurchaseOrderPreview}
                                                        //changeHeader={this.props.changeHeader}
                                                        onReceivedChange={this.props.onReceivedChange}
                                                        updatePurchaseOrder={this.props.updatePurchaseOrder}
                                                        deleteInventoryReceived={this.props.deleteInventoryReceived}
                                                        key={row.poNumber}
                                                        showDropdown={this.state.dropdownAll}
                                                        editingPo={this.props.editingPO}
                                                        handleEditPo={this.props.handleEditPo}
                                                    />
                                                </>
                                            );
                                        })
                                    }
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </>}
            </>
        )
    }


}

PurchaseOrdersTable.propTypes = {
    updatePurchaseOrder: PropTypes.func,
    deleteInventoryReceived: PropTypes.func,
    rows: PropTypes.array
}

PurchaseOrdersTable.defaultProps = {
    updatePurchaseOrder: () => {
    },
    deleteInventoryReceived: () => {
    },
    rows: []
}


export default PurchaseOrdersTable;